import { File, UserMinus, UserPlus } from "lucide-react";

import { capitalize } from "components/helpers";
import EntryDetails from "components/LogItem/elements/EntryDetails";
import { importSuffix } from "components/LogItem/messages/importSuffix";

const assignmentEntry = status => {
  const verb = status.split("_")[0];
  return {
    title: ({ category }) =>
      `${category === "case" ? "Investigator" : "User"} ${capitalize(verb)}`,
    icon: status === "assigned_user" ? UserPlus : UserMinus,
    message: ({ user_name, info }) => (
      <p>
        {user_name || "System"} {verb} {info[status].name}
        {importSuffix(info.data_job_id)}.
      </p>
    ),
  };
};

export const JOB_EVENTS = {
  data_job_created: {
    title: "Data Job Created",
    icon: File,
    message: ({ info: { user } }) => (
      <p>{user.full_name} created the data job.</p>
    ),
  },
  data_job_error: {
    title: "Data Job Error",
    icon: File,
    message: () => <p>An error occurred while processing the data job.</p>,
  },
  data_job_progress: {
    title: "Data Job Progress",
    icon: File,
    message: ({ info: { status } }) => (
      <>
        <p>The data job import is in progress.</p>
        <EntryDetails rows={[{ label: "Status", value: status }]} />
      </>
    ),
  },
  data_job_completed: {
    title: "Data Job Completed",
    icon: File,
    message: () => <p>The data job import has completed.</p>,
  },
  data_job_deleted: {
    title: "Data Job Deleted",
    icon: File,
    message: () => <p>The data job was deleted.</p>,
  },
  assigned_user: assignmentEntry("assigned_user"),
  unassigned_user: assignmentEntry("unassigned_user"),
};
